<template>
  <ClientOnly>
    <div
      v-if="video && video[0]"
      id="wistia_13.thumb_container"
      :class="{
        ['wistia_embed wistia_async_' + video[0].hashed_id]: true,
        'popover=true popoverContent=html inline-wistia inline': true,
      }"
    >
      <span
        v-if="linkStyle == 'hyperLink'"
        :class="{
          'whitespace-nowrap text-2xl font-semibold text-www-color-primary-lighter underline hover:cursor-pointer': true,
        }"
        >{{ linkText }}</span
      >
      <Button
        v-else
        :button-props="{ text: linkText, _type: 'button', style: 'primary' }"
      />
    </div>
  </ClientOnly>
</template>
<script lang="ts" setup>
import type { InlineWistiaVideo } from '~/sanity/types';
import Button from '~/components/Atoms/Button/Button.vue';
import { useWistiaVideo } from '~/composables/useWistiaVideo';

const props = defineProps<InlineWistiaVideo>();
useWistiaVideo({ hashedId: () => props.video?.[0]?.hashed_id });
</script>
